import { useEffect, useReducer } from 'react'
import reducer, {
  initState,
  setSearchDataAction,
  setDataSourceAction,
  setCheckDataAction,
  setLoadingAction,
  setPagesAction,
  setTagsDataAction,
  getDataAction,
  setCountDataAction,
  State,
  Tag as TagType,
  setStatusSearchDataAction,
  changeDataAction,
  setImportModalOpenAction,
  setImportUploadListAction,
  setImportOriginFileAction,
  setImportConfirmLoadingAction,
} from './reducer'
import { OnSearchOption, SearchItemFilter } from '@/components/SearchFilter'
import { message, Modal } from 'antd'
import {
  GET_INQUIRY_LIST_ITEMS,
  GET_INQUIRY_TABCOUNTS,
  InquiryOrderItemDTO,
  InquiryOrderQueryDTO,
  GET_INQUIRY_DETAIL,
  EXPORT_INQUIRY,
  EXPORT_INQUIRY_DETAIL_PAGE,
} from '@/api/inquiry'

import { setModuleDataAction } from '@/modules/pagecache'
import { history, useTypedSelector } from '@/redux/store'
import { useDispatch } from 'react-redux'
import { isResponseCodeSuccess, isResponseSuccess } from '@/tools'
import { StatusSearchDataEnum } from '.'
import { SUPROUTE } from '@/route'
import { useAliveController } from 'react-activation'
import { useQuery } from '@/tools/utilHooks'
import { IMPORT_INQUIRY } from '@/api/inquiry'
import { fileFile } from '@/modules/uploadfiles/hooks'
import { RcFile } from 'antd/lib/upload'
import { uniq } from 'lodash'

const useHook = () => {
  const [state, dispatch] = useReducer(reducer, initState)
  const { drop } = useAliveController()
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const dispatchredux = useDispatch()
  const query = useQuery()
  const tab = query.get('tab') || ''
  const status = query.get('status') || ''
  const { checkData } = state
  useEffect(() => {
    // const flag = getpagecache()
    // if (flag) {
    //   // 恢复缓存数据
    //   dispatch(changeDataAction(flag))
    // } else {
    if (tab) {
      const tabValue = Number(tab)
      let initialSearchData: any = {}
      if (status) {
        initialSearchData.status = status
      }
      dispatch(setStatusSearchDataAction(tabValue))
      const searchData = {
        ...state.searchData,
        ...initialSearchData,
      }
      dispatch(setSearchDataAction(searchData))
      const initialPayload = {
        ...state,
        statusSearchData: tabValue,
        searchData,
      }

      getTableData(initialPayload)
      return
    } else {
      getTableData(state, { flag: true })
    }
    // }
    // eslint-disable-next-line
  }, [tab])

  // useEffect(() => {
  //   // 缓存存数据
  //   const pathName = history.location.pathname
  //   const action = setModuleDataAction({
  //     key: pathName,
  //     data: state,
  //   })
  //   dispatchredux(action)
  //   // eslint-disable-next-line
  // }, [state])

  const getpagecache = () => {
    // 从 Redux store 中查找当前页面的缓存数据
    const currentPath = history.location.pathname
    const cachedData = pagekey.find((item) => item.key === currentPath)

    if (cachedData) {
      return cachedData.data
    }
    return null
  }

  const onSearch = (searchData: SearchItemFilter, options?: OnSearchOption) => {
    dispatch(setSearchDataAction(searchData))
    resetSelection()

    let newTagsData = state.tagsData
    if (options?.isReset) {
      newTagsData = state.tagsData.map((tag) => ({ ...tag, checked: false }))
      dispatch(setTagsDataAction(newTagsData))
    }

    // 搜索时重置页码到第一页
    const newState = {
      ...state,
      searchData,
      tagsData: newTagsData,
      pages: {
        ...state.pages,
        pageNo: 1,
      },
    }

    getTableData(newState, { reset: options?.isReset })
  }

  const getdata = async (payload: State) => {
    dispatch(setLoadingAction(true))
    try {
      const params = {
        ...payload.pages,
        ...payload.searchData,
      }

      payload.tagsData.forEach((tag: TagType) => {
        params[tag.fieldKey] = tag.checked ? 1 : ''
      })

      const res = await GET_INQUIRY_LIST_ITEMS(params as InquiryOrderQueryDTO)

      if (isResponseCodeSuccess(res.code)) {
        const dataSource = res.data.content.map((item: any) => item)
        const groupCounter = new Map<string, number>()
        const marked = dataSource.map((item: any) => {
          const key = item.inquiryNo || ''
          const count = groupCounter.get(key) || 0
          const isFirst = count === 0
          groupCounter.set(key, count + 1)
          return { ...item, __isFirstOfInquiry: isFirst }
        })

        dispatch(
          setDataSourceAction({
            dataSource: {
              data: marked,
              total: res.data.totalCount,
            },
            pageNo: res.data.pageNo,
          }),
        )

        const _pages = {
          pageNo: res.data.pageNo,
          pageSize: res.data.pageSize,
        }
        dispatch(setPagesAction(_pages))
      }
    } catch (error) {
    } finally {
      dispatch(setLoadingAction(false))
    }
  }

  const getTableData = async (
    payload: State,
    options?: {
      // tab 控制
      flag?: boolean
      // 重置时需要判断
      reset?: boolean
    },
  ) => {
    const { flag = false, reset = false } = options || {}
    const params = {
      ...payload.pages,
      ...payload.searchData,
      completionStatus: payload.statusSearchData,
    }

    payload.tagsData.forEach((tag: TagType) => {
      params[tag.fieldKey] = tag.checked ? 1 : ''
    })

    const res = await GET_INQUIRY_TABCOUNTS(params as InquiryOrderQueryDTO)
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setCountDataAction(res.data))

      let currentStatus: string | number = payload.statusSearchData

      // 只在初始化时设置默认状态，搜索时不改变用户选择的状态
      if (flag) {
        if (res.data.unfinishedCount > 0) {
          dispatch(setStatusSearchDataAction(StatusSearchDataEnum.PENDING))
        } else {
          dispatch(setStatusSearchDataAction(StatusSearchDataEnum.ALL))
        }

        currentStatus =
          res.data.unfinishedCount > 0
            ? StatusSearchDataEnum.PENDING
            : StatusSearchDataEnum.ALL
      }

      // 获取当前状态，如果用户已经选择了状态则使用用户的选择

      const finalPayload = {
        ...payload,
        searchData: {
          ...payload.searchData,
          completionStatus: currentStatus,
        },
      }

      getdata(finalPayload)
    } else {
      message.error(res.msg || '获取数量失败')
    }
  }

  const onRefresh = () => {
    getTableData(state)
  }

  const onChange = (page: number, pageSize?: number) => {
    dispatch(setLoadingAction(true))
    dispatch(setPagesAction({ pageNo: page, pageSize: pageSize }))

    getTableData({
      ...state,
      ...{
        pages: {
          pageNo: page,
          pageSize: pageSize ? pageSize : 30,
        },
      },
    })
  }

  function resetSelection() {
    dispatch(setCheckDataAction([]))
  }
  const onChangeCheck = (
    selectedRowKeys: React.Key[],
    selectedRows: InquiryOrderItemDTO[],
  ) => {
    dispatch(setCheckDataAction(selectedRows))
  }

  const onBatchExport = async () => {
    if (checkData.length < 1) {
      message.error('请先选择需要导出的询价单')
      return
    }

    // 询价单号区分同一个订单
    const inquiryNos = uniq(
      checkData.map((item) => item.inquiryNo || '').filter(Boolean),
    )
    const isMultiple = inquiryNos.length > 1
    const res: any = await EXPORT_INQUIRY({
      inquiryItemIds: checkData.map((item) => item.inquiryItemId || ''),
      multiple: isMultiple,
    })
    if (isMultiple) {
      if (isResponseSuccess(res)) {
        message.success('已转移至任务中心执行')
      } else {
        message.error(res.msg)
      }
    }
  }

  const onImportOpenChange = (open: boolean) => {
    dispatch(setImportModalOpenAction(open))
  }

  const onImportFileChange = (list: fileFile[]) => {
    dispatch(setImportUploadListAction(list))
  }

  const getImportOriginFile = (file: RcFile) => {
    dispatch(setImportOriginFileAction(file))
  }

  const onConfirmImport = async () => {
    const { importOriginFile } = state
    if (!importOriginFile) {
      message.error('请先选择需要导入的文件')
      return
    }
    dispatch(setImportConfirmLoadingAction(true))
    try {
      const res = await IMPORT_INQUIRY(importOriginFile)
      if (isResponseSuccess(res)) {
        message.success('已转移至任务中心执行')
        dispatch(setImportModalOpenAction(false))
        dispatch(setImportUploadListAction([]))
        dispatch(setImportOriginFileAction(undefined))
        onRefresh()
      } else {
        message.error(res?.msg || '导入失败')
      }
    } catch (e: any) {
      message.error(e?.message || '导入失败')
    } finally {
      dispatch(setImportConfirmLoadingAction(false))
    }
  }

  const handleChange = (value: string) => {
    // 1) 切换当前点击标签，其余保持不变（可组合）
    const toggledTags = state.tagsData.map((tag) =>
      tag.value === value ? { ...tag, checked: !tag.checked } : tag,
    )
    dispatch(setTagsDataAction(toggledTags))

    getTableData({ ...state, tagsData: toggledTags })
  }

  const handleStatusChange = (value: string | number) => {
    const numValue = Number(value)
    console.log('handleStatusChange 调用，新值:', numValue)
    dispatch(setStatusSearchDataAction(numValue))
    const statusObj = {
      completionStatus: value,
    }

    // 保留现有的搜索条件，只更新 completionStatus
    const newSearchData = {
      ...state.searchData,
      ...statusObj,
    }

    dispatch(setSearchDataAction(newSearchData))

    const payload = {
      ...state,
      searchData: newSearchData,
      statusSearchData: numValue, // 确保传递最新的状态值
    }
    console.log('传递给 getOrderCount 的 payload:', payload)
    getTableData(payload)
  }

  const jumpDetail = async (record: InquiryOrderItemDTO) => {
    await drop('inquiryDetail')
    history.push({
      pathname: `${SUPROUTE}/inquiryDetail`,
      search: `id=${record.inquiryId}`,
    })
  }

  return {
    state,
    onSearch,
    onRefresh,
    onChange,
    onChangeCheck,
    onBatchExport,

    handleChange,

    handleStatusChange,
    jumpDetail,

    onImportOpenChange,
    onImportFileChange,
    getImportOriginFile,
    onConfirmImport,
  }
}

export default useHook
import { useEffect, useReducer } from 'react'
import reducer, {
  initState,
  setSearchDataAction,
  setDataSourceAction,
  setCheckDataAction,
  setLoadingAction,
  setPagesAction,
  setTagsDataAction,
  getDataAction,
  setCountDataAction,
  State,
  Tag as TagType,
  setStatusSearchDataAction,
  changeDataAction,
  setImportModalOpenAction,
  setImportUploadListAction,
  setImportOriginFileAction,
  setImportConfirmLoadingAction,
} from './reducer'
import { OnSearchOption, SearchItemFilter } from '@/components/SearchFilter'
import { message, Modal } from 'antd'
import {
  GET_INQUIRY_LIST_ITEMS,
  GET_INQUIRY_TABCOUNTS,
  InquiryOrderItemDTO,
  InquiryOrderQueryDTO,
  GET_INQUIRY_DETAIL,
  EXPORT_INQUIRY,
  EXPORT_INQUIRY_DETAIL_PAGE,
} from '@/api/inquiry'

import { setModuleDataAction } from '@/modules/pagecache'
import { history, useTypedSelector } from '@/redux/store'
import { useDispatch } from 'react-redux'
import { isResponseCodeSuccess, isResponseSuccess } from '@/tools'
import { StatusSearchDataEnum } from '.'
import { SUPROUTE } from '@/route'
import { useAliveController } from 'react-activation'
import { useQuery } from '@/tools/utilHooks'
import { IMPORT_INQUIRY } from '@/api/inquiry'
import { fileFile } from '@/modules/uploadfiles/hooks'
import { RcFile } from 'antd/lib/upload'
import { uniq } from 'lodash'

const useHook = () => {
  const [state, dispatch] = useReducer(reducer, initState)
  const { drop } = useAliveController()
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const dispatchredux = useDispatch()
  const query = useQuery()
  const tab = query.get('tab') || ''
  const status = query.get('status') || ''
  const { checkData } = state
  useEffect(() => {
    // const flag = getpagecache()
    // if (flag) {
    //   // 恢复缓存数据
    //   dispatch(changeDataAction(flag))
    // } else {
    if (tab) {
      const tabValue = Number(tab)
      let initialSearchData: any = {}
      if (status) {
        initialSearchData.status = status
      }
      dispatch(setStatusSearchDataAction(tabValue))
      const searchData = {
        ...state.searchData,
        ...initialSearchData,
      }
      dispatch(setSearchDataAction(searchData))
      const initialPayload = {
        ...state,
        statusSearchData: tabValue,
        searchData,
      }

      getTableData(initialPayload)
      return
    } else {
      getTableData(state, { flag: true })
    }
    // }
    // eslint-disable-next-line
  }, [tab])

  // useEffect(() => {
  //   // 缓存存数据
  //   const pathName = history.location.pathname
  //   const action = setModuleDataAction({
  //     key: pathName,
  //     data: state,
  //   })
  //   dispatchredux(action)
  //   // eslint-disable-next-line
  // }, [state])

  const getpagecache = () => {
    // 从 Redux store 中查找当前页面的缓存数据
    const currentPath = history.location.pathname
    const cachedData = pagekey.find((item) => item.key === currentPath)

    if (cachedData) {
      return cachedData.data
    }
    return null
  }

  const onSearch = (searchData: SearchItemFilter, options?: OnSearchOption) => {
    dispatch(setSearchDataAction(searchData))
    resetSelection()

    let newTagsData = state.tagsData
    if (options?.isReset) {
      newTagsData = state.tagsData.map((tag) => ({ ...tag, checked: false }))
      dispatch(setTagsDataAction(newTagsData))
    }

    // 搜索时重置页码到第一页
    const newState = {
      ...state,
      searchData,
      tagsData: newTagsData,
      pages: {
        ...state.pages,
        pageNo: 1,
      },
    }

    getTableData(newState, { reset: options?.isReset })
  }

  const getdata = async (payload: State) => {
    dispatch(setLoadingAction(true))
    try {
      const params = {
        ...payload.pages,
        ...payload.searchData,
      }

      payload.tagsData.forEach((tag: TagType) => {
        params[tag.fieldKey] = tag.checked ? 1 : ''
      })

      const res = await GET_INQUIRY_LIST_ITEMS(params as InquiryOrderQueryDTO)

      if (isResponseCodeSuccess(res.code)) {
        const dataSource = res.data.content.map((item: any) => item)
        const groupCounter = new Map<string, number>()
        const marked = dataSource.map((item: any) => {
          const key = item.inquiryNo || ''
          const count = groupCounter.get(key) || 0
          const isFirst = count === 0
          groupCounter.set(key, count + 1)
          return { ...item, __isFirstOfInquiry: isFirst }
        })

        dispatch(
          setDataSourceAction({
            dataSource: {
              data: marked,
              total: res.data.totalCount,
            },
            pageNo: res.data.pageNo,
          }),
        )

        const _pages = {
          pageNo: res.data.pageNo,
          pageSize: res.data.pageSize,
        }
        dispatch(setPagesAction(_pages))
      }
    } catch (error) {
    } finally {
      dispatch(setLoadingAction(false))
    }
  }

  const getTableData = async (
    payload: State,
    options?: {
      // tab 控制
      flag?: boolean
      // 重置时需要判断
      reset?: boolean
    },
  ) => {
    const { flag = false, reset = false } = options || {}
    const params = {
      ...payload.pages,
      ...payload.searchData,
      completionStatus: payload.statusSearchData,
    }

    payload.tagsData.forEach((tag: TagType) => {
      params[tag.fieldKey] = tag.checked ? 1 : ''
    })

    const res = await GET_INQUIRY_TABCOUNTS(params as InquiryOrderQueryDTO)
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setCountDataAction(res.data))

      let currentStatus: string | number = payload.statusSearchData

      // 只在初始化时设置默认状态，搜索时不改变用户选择的状态
      if (flag) {
        if (res.data.unfinishedCount > 0) {
          dispatch(setStatusSearchDataAction(StatusSearchDataEnum.PENDING))
        } else {
          dispatch(setStatusSearchDataAction(StatusSearchDataEnum.ALL))
        }

        currentStatus =
          res.data.unfinishedCount > 0
            ? StatusSearchDataEnum.PENDING
            : StatusSearchDataEnum.ALL
      }

      // 获取当前状态，如果用户已经选择了状态则使用用户的选择

      const finalPayload = {
        ...payload,
        searchData: {
          ...payload.searchData,
          completionStatus: currentStatus,
        },
      }

      getdata(finalPayload)
    } else {
      message.error(res.msg || '获取数量失败')
    }
  }

  const onRefresh = () => {
    getTableData(state)
  }

  const onChange = (page: number, pageSize?: number) => {
    dispatch(setLoadingAction(true))
    dispatch(setPagesAction({ pageNo: page, pageSize: pageSize }))

    getTableData({
      ...state,
      ...{
        pages: {
          pageNo: page,
          pageSize: pageSize ? pageSize : 30,
        },
      },
    })
  }

  function resetSelection() {
    dispatch(setCheckDataAction([]))
  }
  const onChangeCheck = (
    selectedRowKeys: React.Key[],
    selectedRows: InquiryOrderItemDTO[],
  ) => {
    dispatch(setCheckDataAction(selectedRows))
  }

  const onBatchExport = async () => {
    if (checkData.length < 1) {
      message.error('请先选择需要导出的询价单')
      return
    }

    // 询价单号区分同一个订单
    const inquiryNos = uniq(
      checkData.map((item) => item.inquiryNo || '').filter(Boolean),
    )
    const isMultiple = inquiryNos.length > 1
    const res: any = await EXPORT_INQUIRY({
      inquiryItemIds: checkData.map((item) => item.inquiryItemId || ''),
      multiple: isMultiple,
    })
    if (isMultiple) {
      if (isResponseSuccess(res)) {
        message.success('已转移至任务中心执行')
      } else {
        message.error(res.msg)
      }
    }
  }

  const onImportOpenChange = (open: boolean) => {
    dispatch(setImportModalOpenAction(open))
  }

  const onImportFileChange = (list: fileFile[]) => {
    dispatch(setImportUploadListAction(list))
  }

  const getImportOriginFile = (file: RcFile) => {
    dispatch(setImportOriginFileAction(file))
  }

  const onConfirmImport = async () => {
    const { importOriginFile } = state
    if (!importOriginFile) {
      message.error('请先选择需要导入的文件')
      return
    }
    dispatch(setImportConfirmLoadingAction(true))
    try {
      const res = await IMPORT_INQUIRY(importOriginFile)
      if (isResponseSuccess(res)) {
        message.success('已转移至任务中心执行')
        dispatch(setImportModalOpenAction(false))
        dispatch(setImportUploadListAction([]))
        dispatch(setImportOriginFileAction(undefined))
        onRefresh()
      } else {
        message.error(res?.msg || '导入失败')
      }
    } catch (e: any) {
      message.error(e?.message || '导入失败')
    } finally {
      dispatch(setImportConfirmLoadingAction(false))
    }
  }

  const handleChange = (value: string) => {
    // 1) 切换当前点击标签，其余保持不变（可组合）
    const toggledTags = state.tagsData.map((tag) =>
      tag.value === value ? { ...tag, checked: !tag.checked } : tag,
    )
    dispatch(setTagsDataAction(toggledTags))

    getTableData({ ...state, tagsData: toggledTags })
  }

  const handleStatusChange = (value: string | number) => {
    const numValue = Number(value)
    console.log('handleStatusChange 调用，新值:', numValue)
    dispatch(setStatusSearchDataAction(numValue))
    const statusObj = {
      completionStatus: value,
    }

    // 保留现有的搜索条件，只更新 completionStatus
    const newSearchData = {
      ...state.searchData,
      ...statusObj,
    }

    dispatch(setSearchDataAction(newSearchData))

    const payload = {
      ...state,
      searchData: newSearchData,
      statusSearchData: numValue, // 确保传递最新的状态值
    }
    console.log('传递给 getOrderCount 的 payload:', payload)
    getTableData(payload)
  }

  const jumpDetail = async (record: InquiryOrderItemDTO) => {
    await drop('inquiryDetail')
    history.push({
      pathname: `${SUPROUTE}/inquiryDetail`,
      search: `id=${record.inquiryId}`,
    })
  }

  return {
    state,
    onSearch,
    onRefresh,
    onChange,
    onChangeCheck,
    onBatchExport,

    handleChange,

    handleStatusChange,
    jumpDetail,

    onImportOpenChange,
    onImportFileChange,
    getImportOriginFile,
    onConfirmImport,
  }
}

export default useHook
